<template>
  <el-dialog
    title="Edit Entry"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    @close="closeDialog()"
    width="400px"
  >
    <el-form label-width="65px" :model="form" :rules="rules" ref="form">
      <el-form-item :label="$t('text.time')" prop="time">
        {{ form.time }}
      </el-form-item>
      <el-form-item :label="$t('text.volume')" prop="volume">
        <el-input-number
          v-model="form.volume"
          controls-position="right"
          :min="0"
        ></el-input-number>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button class="save-btn min-w-80" @click="save()">{{
        $t('text.save').toUpperCase()
      }}</el-button>
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      index: '',
      form: {
        time: '',
        volume: ''
      },
      rules: {
        time: [
          {
            required: true,
            message: 'time is required',
            trigger: 'blur'
          }
        ],
        volume: [
          {
            required: true,
            message: this.$t('text.void_required'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.form = {
        time: '',
        volume: ''
      }
      this.$refs.form.resetFields()
      this.dialogVisible = false
    },
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$set(this.$parent.volData, this.index, {
            localtime: this.$parent.volData[this.index].localtime,
            time: this.$parent.volData[this.index].time,
            volume: this.form.volume
          })
          this.closeDialog()
        }
      })
    }
  }
}
</script>
